interface TrendingUpProps {
  size?: 'small' | 'medium' | 'large'
}

export const TrendingUp = ({ size = 'medium' }: TrendingUpProps) => {
  const getSize = () => {
    switch (size) {
      case 'small':
        return { width: 16, height: 10 }
      case 'medium':
        return { width: 22, height: 14 }
      case 'large':
        return { width: 32, height: 20 }
      default:
        return { width: 22, height: 14 }
    }
  }

  const { width, height } = getSize()

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 14" fill="none">
      <path
        d="M21.4999 1.25V7.25C21.4999 7.44891 21.4209 7.63968 21.2803 7.78033C21.1396 7.92098 20.9488 8 20.7499 8C20.551 8 20.3603 7.92098 20.2196 7.78033C20.0789 7.63968 19.9999 7.44891 19.9999 7.25V3.06031L12.2806 10.7806C12.2109 10.8504 12.1282 10.9057 12.0371 10.9434C11.9461 10.9812 11.8485 11.0006 11.7499 11.0006C11.6514 11.0006 11.5538 10.9812 11.4627 10.9434C11.3717 10.9057 11.289 10.8504 11.2193 10.7806L7.99993 7.56031L1.78055 13.7806C1.63982 13.9214 1.44895 14.0004 1.24993 14.0004C1.05091 14.0004 0.860034 13.9214 0.719304 13.7806C0.578573 13.6399 0.499512 13.449 0.499512 13.25C0.499512 13.051 0.578573 12.8601 0.719304 12.7194L7.4693 5.96937C7.53896 5.89964 7.62168 5.84432 7.71272 5.80658C7.80377 5.76884 7.90137 5.74941 7.99993 5.74941C8.09849 5.74941 8.19609 5.76884 8.28713 5.80658C8.37818 5.84432 8.4609 5.89964 8.53055 5.96937L11.7499 9.18969L18.9396 2H14.7499C14.551 2 14.3603 1.92098 14.2196 1.78033C14.0789 1.63968 13.9999 1.44891 13.9999 1.25C13.9999 1.05109 14.0789 0.860322 14.2196 0.71967C14.3603 0.579018 14.551 0.5 14.7499 0.5H20.7499C20.9488 0.5 21.1396 0.579018 21.2803 0.71967C21.4209 0.860322 21.4999 1.05109 21.4999 1.25Z"
        fill="currentColor"
      />
    </svg>
  )
}
